/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["#mapping{flex:1 1 auto;display:flex;flex-direction:column}#mapping a.csvfloat{top:1rem;right:1.5rem;padding:0}"];
export { styles as styles };
